import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { tap } from 'rxjs/operators';

import { Note, NoteCreateDto, NoteEntityClass, NotesService, NoteUpdateDto, User } from '@assess/browser/api';

@Component({
  selector: 'assess-note-form',
  templateUrl: './note-form.component.html',
  styleUrls: ['./note-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoteFormComponent implements OnInit {
  form!: FormGroup;
  @Input() entityId!: string;
  @Input() entityClass!: NoteEntityClass;
  @Input() noteContent!: string | undefined;
  @Input() entityVersion!: number | undefined;
  @Input() noteId!: string | undefined;
  @Input() author!: User | undefined;
  @Output() noteSaved = new EventEmitter<Note>();
  @Output() cancel = new EventEmitter();
  isPreexistingNote!: boolean;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly notesService: NotesService
  ) {}

  ngOnInit(): void {
    this.isPreexistingNote = !!this.noteId;
    this.form = this.formBuilder.group({
      note: [this.noteContent || '', Validators.required],
    });
  }

  onCreateNote() {
    const note: NoteCreateDto = { content: this.form.value.note };
    this.notesService
      .createNote({ entityClass: this.entityClass, entityId: this.entityId, body: note })
      .pipe(tap((newNote) => this.noteSaved.emit(newNote)))
      .subscribe();
  }

  onSaveNote() {
    const id = this.noteId;
    const entityVersion = this.entityVersion;
    if (id && entityVersion) {
      const body: NoteUpdateDto = { content: this.form.value.note, id, entityVersion };
      this.notesService
        .updateNote({ entityClass: this.entityClass, entityId: this.entityId, body })
        .pipe(tap(() => this.noteSaved.emit()))
        .subscribe();
    }
  }
}
